import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { Container, Row, Col, Button, Form, Spinner } from "react-bootstrap";
import { useQuery } from "@tanstack/react-query";
import useHrApi from "../../services/hr/hrAPI";
import { useHistory } from "react-router-dom";
import { GetCurrentUserName } from "../../utils/permissionChecker";
const ChoosePayrollMonth = ({ closeModal }) => {
  const { t } = useTranslation();
  let history = useHistory();
  const loggedInUser = GetCurrentUserName();
  const { getAllBranch } = useHrApi();
  const getBranchQuery = useQuery(["get_employee_branch"], () =>
    getAllBranch()
  );
  if (getBranchQuery.isLoading) {
    return <div>Loading...</div>;
  }
  if (getBranchQuery.isError) {
    return <div>Error: {getBranchQuery.error.message}</div>;
  }
  const branch = getBranchQuery.data;
  const initialValues = {
    month: "",
    branch_id: "",
  };
  const validationSchema = Yup.object().shape({
    month: Yup.string().trim().required("payroll month is required"),
    branch_id: Yup.string().required("branch is required"),
  });

  const editPayroll = (values) => {
    const passParameter = { month: 3, year: 2024, branch: "333333344" };
    history.push("/payroll/edit-payroll", {
      payrollMonth: passParameter,
    });
  };

  const creatPayrollSheet = async () => {
    const passParameter = { month: 3, year: 2024, branch: "333333344" };
    history.push("/payroll/creat-payroll-sheet", {
      payrollMonth: passParameter,
    });
  };
  return (
    <Container fluid>
      <Row>
        <Col lg="12">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={creatPayrollSheet}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <Form.Group controlId="payroll_month">
                  <Form.Label>{t("month")}</Form.Label>
                  <Form.Control
                    type="date"
                    name="month"
                    value={values.month}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.month && !!errors.month}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.month}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="branch_id">
                  <Form.Label>{t("branch")}</Form.Label>
                  <Form.Control
                    as="select"
                    name="branch_id"
                    value={values.branch_id}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.branch_id && !!errors.branch_id}
                  >
                    <option value="" disabled>
                      {t("select_branch")}
                    </option>
                    {branch &&
                      branch.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.branch_id}
                  </Form.Control.Feedback>
                </Form.Group>
                <Button
                  className="mr-2"
                  variant="secondary"
                  onClick={closeModal}
                >
                  {t("close")}
                </Button>
                <Button
                  className=" btn btn-info mr-1"
                  variant="primary"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <span>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="false"
                      />
                      <span className="visually-hidden">Sending...</span>
                    </span>
                  ) : (
                    t("create")
                  )}
                </Button>
                <Button className="mr-2" variant="info" onClick={editPayroll}>
                  {t("edit")}
                </Button>
              </Form>
            )}
          </Formik>
        </Col>
      </Row>
    </Container>
  );
};

export default ChoosePayrollMonth;
